import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import Button from "../../../../modules/commons/Button";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import { tableColumns } from "../config";
import Detail from "../common/detail";
import Filter from "../common/filter";
import { defaultTableChange } from "../../../../modules/custom/customTable";
import M from "moment/moment";

const FORMAT_DATE = "DD-MM-YYYY";

class SudahDelivery extends Component {
  tableColumns = [
    ...tableColumns,
    {
      name: "deliveryManId",
      label: "Nama Sopir",
    },
    {
      name: "deliveryDoneDate",
      label: "Tgl Seleai Kirim",
    },
    {
      name: "deliveryDoneTime",
      label: "Jam Selesai Kirim",
    },
    {
      name: "deliveryId",
      label: "Aksi",
      options: {
        customBodyRender: (val) => (
          <Button
            className="btnAct"
            style={{ marginRight: 15, backgroundColor: "transparent" }}
            onClick={() => this.handleDetailVisibility(val)}
          >
            <i
              className="fa fa-file-signature"
              style={{
                backgroundColor: "transparent",
                color: "red",
                fontSize: 20,
              }}
            />
          </Button>
        ),
      },
    },
  ];

  constructor(props) {
    super(props);
    this.state = {
      detailId: "",
    };
  }

  handleFilterVisibility = () => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      filterVisible: !prevValue.filterVisible,
    }));
  };

  handleDetailVisibility = (id) => {
    this.setState((prevValue) => ({ ...prevValue, detailId: id }));
  };

  handleValueChange = (name, value) => {
    this.props.onSetState((prevValue) => ({
      ...prevValue,
      searchData: {
        ...prevValue.searchData,
        [name]: value,
      },
    }));
  };

  getDataValue(fieldName) {
    return this.props.state.searchData && this.props.state.searchData[fieldName]
      ? this.props.state.searchData[fieldName]
      : null;
  }

  render() {
    return (
      <div>
        <FlexView
          style={{ justifyContent: "flex-end", gap: "50px" }}
          vAlignContent="center"
          className="margin-top-5px"
        >
          <form onSubmit={this.props.onSearch}>
            <FlexView vAlignContent="center" style={{ gap: "10px" }}>
              <p className="margin-left-25px margin-bottom-20px">Periode</p>
              <SimpleDate
                id="select_date_startDateDelivery"
                name="startDateDelivery"
                nextdate
                date={this.getDataValue("startDateDelivery")}
                maxDate={this.getDataValue("endDateDelivery")}
                onChange={(value) => this.handleValueChange("startDateDelivery", M(value).format(FORMAT_DATE))}
              />
              <SimpleDate
                id="select_date_endDateDelivery"
                name="endDateDelivery"
                backdate
                date={this.getDataValue("endDateDelivery")}
                minDate={this.getDataValue("startDateDelivery")}
                onChange={(value) => this.handleValueChange("endDateDelivery", M(value).format(FORMAT_DATE))}
              />
              <SimpleButton type="submit" className="margin-bottom-20px">
                Cari
              </SimpleButton>
            </FlexView>
          </form>
          <Button
            type="button"
            onClick={this.handleFilterVisibility}
            className="btn background-red margin-bottom-20px"
          >
            <span>
              <i className="fa fa-qrcode"></i>
            </span>
          </Button>
        </FlexView>
        <SimpleDataTable
          toCount={this.props.state.pagination.totalData}
          data={this.props.state.dataTable}
          columns={this.tableColumns}
          rowsPerPage={this.props.state.pagination.limit}
          page={this.props.state.pagination.page - 1}
          options={defaultTableChange(this.props.onChangePage, this.props.onChangeRowsPerPage)}
        />
        {this.props.state.filterVisible && (
          <Filter
            state={this.props.state}
            onClickClose={this.handleFilterVisibility}
            onSetState={this.props.onSetState}
            onSubmit={this.props.onSubmitFilter}
          />
        )}
        {this.state.detailId && (
          <Detail
              {...this.props}
            id={this.state.detailId}
            viewOnly
            onClickClose={() => this.handleDetailVisibility("")}
          />
        )}
      </div>
    );
  }
}

export default SudahDelivery;
